if (typeof Plyr !== 'undefined' && !window.plyrVideoObserverInitialized) {
  window.plyrVideoObserverInitialized = true;

  const initVideoPlyr = (video) => {
    if (!video || video.dataset.plyrInitialized) return;
    video.dataset.plyrInitialized = 'true';

    new Plyr(video, {
      controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
    });
  };

  document.querySelectorAll('video[controls]').forEach(initVideoPlyr);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches('video[controls]')) initVideoPlyr(node);
        node.querySelectorAll?.('video[controls]').forEach(initVideoPlyr);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}
